/* Package JSON Import will be here */
import _ from "lodash";
/* Package JSON Import will be here */

/* Project Import will be here */
import { getSearchProductsApi, searchByBarcodeApi } from "services/home";
import {
  getErrorObject,
  normalize,
  mergeMultipleSchemeProducts,
  errorToast
} from "utilities/utils";
import { ISearchProductParams } from "models/homeModels";
import { navigateToProductDetail } from "app/navigation";
import { showMsgFromJson } from "reducers/common";
import Constants from "utilities/appConstants";
/* Project Import will be here */

export const types = {
  SEARCH_PRODUCTS_REQUEST: "search/SEARCH_PRODUCTS_REQUEST",
  SEARCH_PRODUCTS_SUCCESS: "search/SEARCH_PRODUCTS_SUCCESS",
  SEARCH_PRODUCTS_FAILURE: "search/SEARCH_PRODUCTS_FAILURE",
  BAR_CODE_SEARCH_PRODUCTS_LOADER: "search/BAR_CODE_SEARCH_PRODUCTS_LOADER"
};

const initialState = {
  searchText: "",
  isLoading: false,
  data: {},
  ids: [],
  error: null,
  isBarCodeLoading: false
};

export const searchProducts = (state = initialState, action) => {
  switch (action.type) {
    case types.SEARCH_PRODUCTS_REQUEST:
      return {
        ...state,
        ...action.payload,
        isLoading: true
      };
    case types.SEARCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        error: null,
        isLoading: false
      };
    case types.SEARCH_PRODUCTS_FAILURE:
      return {
        ...initialState,
        error: action.payload.error
      };
    case types.BAR_CODE_SEARCH_PRODUCTS_LOADER:
      return {
        ...initialState,
        isBarCodeLoading: action.payload.isBarCodeLoading
      };
    default:
      return state;
  }
};

/* Search products based on given text */
export const getSearchProducts = (data: ISearchProductParams) => {
  return async (dispatch, getState) => {
    dispatch({
      type: types.SEARCH_PRODUCTS_REQUEST,
      payload: { searchText: data.SearchText }
    });
    try {
      const response = await getSearchProductsApi(data);

      /* Only store the data if the response matches the latest search text */
      if (getState().searchProducts.searchText === response.data.SearchText) {
        /* Get the data without SUBR */
        const dataWithoutSubBrand = _.filter(response.data.Data, o => {
          return o.Code !== "SUBR";
        });

        const searchProductList = mergeMultipleSchemeProducts(dataWithoutSubBrand);

        let payload = normalize({
          data: searchProductList,
          key: "Id"
        });

        dispatch({ type: types.SEARCH_PRODUCTS_SUCCESS, payload });
      }
    }
    catch (error) {
      const { message } = getErrorObject(error);
      dispatch({
        type: types.SEARCH_PRODUCTS_FAILURE,
        payload: { error: message }
      });
    }
  };
};

/* Barcode search based on scanned and entered barcode */
export const getProductByBarCode = (data: ISearchProductParams, successResponseCallback, errorResponseCallback, isFromScan) => {
  return async (dispatch, getState) => {
    barcodeLoaderStatus(dispatch, true);
    try {
      const response = await searchByBarcodeApi(data);
      barcodeLoaderStatus(dispatch, false);

      /* Success response call back to close barcode scanner model and search drawer */
      successResponseCallback();

      /* Redirect to product details page with product id */
      dispatch(navigateToProductDetail(response.data.Data.productId + "/products"));
    }
    catch (error) {
      /* error response call back to hide loader */
      errorResponseCallback(isFromScan);

      const { message, errorCode } = getErrorObject(error);
      barcodeLoaderStatus(dispatch, false);

      /* Show error or warning message */
      if (errorCode !== "")
        dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
      else
        errorToast({ content: message });
    }
  };
};

const barcodeLoaderStatus = (dispatch, status) => {
  dispatch({ type: types.BAR_CODE_SEARCH_PRODUCTS_LOADER, payload: { isBarCodeLoading: status } });
}